import { NgModule } from '@angular/core';
import { TrapFocusDirective } from './trap-focus.directive';

@NgModule({
  declarations: [
    TrapFocusDirective,
  ],
  exports: [
    TrapFocusDirective,
  ],
})
export class TrapFocusModule {
}
